/* eslint-disable prettier/prettier */
/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { CloudinaryContext, Transformation, Video } from "cloudinary-react";
import axios from "axios";
import { Header, Divider, Table } from "semantic-ui-react";
import { Button } from "react-bootstrap";

const Post = ({ description, material, max_watt, bulb_qty, finish, bulb }) => {
  const [videos, setVideos] = useState([]);
  const [publicIds, setPublicIds] = useState([]);
  const [id, setId] = useState(0);

  const getVideos = () => {
    axios
      .get("https://res.cloudinary.com/dafco2hao/video/list/myphotoalbum.json")
      .then(res => {
        setVideos(res.data.resources);
        const result = res.data.resources.map(({ public_id }) => ({
          public_id
        }));
        setPublicIds(result);
      });
  };

  const getNextIndex = () => {
    return id + 1 < publicIds.length ? id + 1 : 0;
  };

  useEffect(() => {
    getVideos();
  }, []);

  const showWidget = () => {
    const uploadOptions = {
      tags: ["myphotoalbum"],
      cloud_name: "dafco2hao",
      upload_preset: "xfkvqoad",
      resource_type: "video",
      folder: "videos",
      moderation: "google_video_moderation:possible"
    };
    const widget = window.cloudinary.createUploadWidget(
      uploadOptions,
      (error, result) => {
        if (!error && result && result.event === "success") {
          console.log(result);
        }
      }
    );
    widget.open();
  };

  return (
    <div>
      <Header as="h3">About this product</Header>
      <p>{description}</p>

      <Divider />

      <Table celled>
        <Table.Header style={{ background: "#f9fafb" }}>
          <Table.Row>
            <Table.HeaderCell colSpan="2">Attributes</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>Material</Table.Cell>
            <Table.Cell>{material}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Max watt.</Table.Cell>
            <Table.Cell>{max_watt}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Bulb qty.</Table.Cell>
            <Table.Cell>{bulb_qty}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Finish</Table.Cell>
            <Table.Cell>{finish}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Fitting</Table.Cell>
            <Table.Cell>{bulb}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <div className="text-center mb-4">
        <a className="btn btn-primary" href="#" onClick={showWidget}>
          Upload Review Video
        </a>
      </div>
      <CloudinaryContext cloudName="dafco2hao">
        {publicIds.length > 0 ? (
          <Header className="text-center" as="h3">
            Videos with No Transformation
          </Header>
        ) : null}
        {videos.map(data => {
          return (
            <div className="container " key={data.public_id}>
              <div className="row py-3">
                <Video
                  className="col-xl-6 p-0 col-12 shadow"
                  publicId={data.public_id}
                  controls={true}
                ></Video>
              </div>
            </div>
          );
        })}
        {publicIds.length > 0 ? (
          <>
            <Header className="text-center mb-4" as="h3">
              Video Playlist with Content Aware Cropping
            </Header>
            <Video
              className=" col-xl-6 col-12 mb-2 shadow"
              publicId={publicIds[id].public_id}
              controls={true}
            >
              <Transformation
                width="300"
                height={window.innerWidth < 600 ? "300" : ""}
                gravity="auto"
                crop="fill"
              />
            </Video>
          </>
        ) : null}
      </CloudinaryContext>
      {publicIds.length > 1 ? (
        <div className="text-center mb-4">
          <Button onClick={() => setId(getNextIndex())} variant="primary">
            Next Video
          </Button>{" "}
        </div>
      ) : null}
    </div>
  );
};

export default Post;
